import React, { Component } from 'react'
import { BrowserRouter, Match } from 'react-router'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'
import Menu from './Menu'
import findIndex from 'lodash.findindex'
import Swipe from './Swipe'
import Logo from './Logo'
import {TimelineMax, TweenMax} from 'gsap'

export default class HomeDesktop extends Component {


  constructor(props){
    super(props)
    this.state = {
      direction: 1
    }
    this.handleSwipe = this.handleSwipe.bind(this)
    this.pageRefs = {}
    this.handlePage = this.handlePage.bind(this)
  }

  handlePage(url, node){
    this.pageRefs[url] = node
  }

  shouldComponentUpdate(){
    return false
  }

  componentDidMount(){
    const nodes = Array.from(document.querySelectorAll('[data-page]'))
      .filter(node => this.pageRefs[this.props.location.pathname] !== node)
    TweenMax
    .set(nodes, {visibility: 'hidden', pointerEvents: 'none'})
  }

  componentWillReceiveProps(newProps){
    if(newProps.location.pathname !== this.props.location.pathname){
      const pageIndex = findIndex(this.props.pages, { url:this.props.location.pathname})
      const nextPageIndex = findIndex(this.props.pages, { url:newProps.location.pathname})
      const direction = (pageIndex > -1 && nextPageIndex > -1)
        ? nextPageIndex > pageIndex ? 1 : -1
        : 0
      // this.setState({ direction })
      this.slideTo(this.pageRefs[newProps.location.pathname], this.pageRefs[this.props.location.pathname], direction)
    }
  }


  slideTo(nodeEntering, nodeLeaving, direction){
    if(!nodeEntering) return
    const nodesEntering = Array.from(nodeEntering.querySelectorAll('[data-animate]'))
    const nodesLeaving = Array.from(nodeLeaving.querySelectorAll('[data-animate]'))
    const nodes = [...nodesEntering, ...nodesLeaving ]
    const duration = 0.8
    const stagger = 0.04
    const ease = TweenMax.Quart.easeInOut
    const timeline = new TimelineMax()

    timeline
      .set(nodeEntering, {visibility: 'visible', pointerEvents: 'none'})
      .set(nodes, {willChange:'transform'})

    nodesEntering.forEach((node, i)=>{
      timeline.add(TweenMax.fromTo(node, duration,
        {
          // z: 200,
          y: window.innerHeight * direction
        },
        {
          y: 0,
          z: 0,
          ease: ease
        }),
        (stagger * nodesLeaving.length) + stagger * (direction > 0 ? i : (nodesEntering.length - i))
      )
    })

    nodesLeaving.forEach((node, i)=>{
      timeline.add(TweenMax.to(node, duration,
        {
          y: - window.innerHeight * direction,
          ease: ease,
          // z: 200,
        }),
         stagger * (direction > 0 ? i : (nodesLeaving.length - i))
      )
    })

    timeline
      .set(nodeEntering, {pointerEvents: 'auto'})
      .set(nodeLeaving, {visibility: 'hidde', pointerEvents: 'none'})
      .set(nodes, {willChange:'none'})
  }

  handleSwipe(direction){
    const {pages, location} = this.props
    const pageIndex = findIndex(pages, { url:location.pathname})
    const nextPageIndex = Math.max(0, Math.min(pages.length - 1, pageIndex + direction))
    const nextPage = pages[nextPageIndex]
    this.context.router.transitionTo(nextPage.url)
  }


  render(){
    return (
      <Swipe
        onSwipe={this.handleSwipe}
        {...style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          minHeight: '100vh',
          display: 'flex',
          background: colors.almostWhite
        })}
      >

        <div
        {...style({
          position: 'absolute',
          top: 0,
          right: 0,
          padding: '4rem',
          textAlign: 'right',
        })}
        >
          <div
          {...style({
            marginBottom: '0rem',
          })}
          >
            <Logo
              {...style({
                fontSize: '1.5rem'
              })}
            />
          </div>
          <div
            {...style({
              display: 'none',
              marginTop: -4,
              marginBottom: '4rem',
            })}
          >
            Conseil creation production
          </div>
        </div>
      <div
        {...style({
          width: '100%',
          minHeight: '100vh',
          display: 'flex',
          background: colors.almostWhite
        })}
      >

        <div
          {...style({
            height: '100vh',
            flex: '1 1 auto',
            overflow: 'hidden'
          })}
        >
          <div
            ref='container'
            {...style({
              position: 'relative',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            })}
          >
            { this.props.pages.map((page, i)=>{
              const Comp = page.desktopComponent || page.component
              return (
                <div
                  data-page
                  key={page.url}
                  ref={node => this.handlePage(page.url, node)}
                  {...style({
                    position: 'absolute',
                    top: 0,
                    left:0,
                    width: '100%',
                    height: '100%',
                    // opacity: 0,
                    padding: '0 4rem',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center'
                  })}
                >
                  <Comp
                    {...page}
                    {...this.props}
                  />
                </div>
              )
            })}
          </div>
        </div>

        <div
          {...style({
            display: 'flex',
            alignItems: 'center',
            color: colors.lightSilver,
            padding: '0 4rem 0 4rem',
            textAlign: 'right'
          })}
        >
          <Menu
            underlineColor={colors.yellow}
            {...this.props}
          />
        </div>

      </div>
      </Swipe>
    )
  }
}

HomeDesktop.contextTypes = {
  router: React.PropTypes.object
}



/** WEBPACK FOOTER **
 ** ./src/components/HomeDesktop.js
 **/